import { useFloatingMenu } from 'articleEditor/hooks/useFloatingMenu';
import { MyImageElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';

import { ImageLinkMenu } from './imageLinkMenu';
import { ImagePickerUploadMenu } from './imagePickerUploadMenu';
// import { useFloating, useInteractions } from '@floating-ui/react';
import { ImageBlockPlaceholder, ImageBlockValue } from '.';

export type ImageBlockProps = RenderElementProps & {
  element: MyImageElement;
};

export default function ImageBlock({
  element,
  attributes,
  children,
}: ImageBlockProps): JSX.Element {
  const uploadMenu = useFloatingMenu();
  const linkMenu = useFloatingMenu();

  return (
    <div>
      {element.url ? (
        <ImageBlockValue
          element={element}
          attributes={attributes}
          floatingUploadMenu={uploadMenu}
          floatingLinkMenu={linkMenu}
        >
          {children}
        </ImageBlockValue>
      ) : (
        <ImageBlockPlaceholder
          element={element}
          attributes={attributes}
          floatingUploadMenu={uploadMenu}
        >
          {children}
        </ImageBlockPlaceholder>
      )}

      <ImagePickerUploadMenu
        element={element}
        floatingUploadMenu={uploadMenu}
      />

      <ImageLinkMenu element={element} floatingLinkMenu={linkMenu} />
    </div>
  );
}
